/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button, Group, Modal, Text, TextInput } from "@mantine/core";
import { useState } from "react";

type addNewPatientProps = {
  modalOpened: boolean;
  setModalOpened: (value: boolean) => void;
  patientName: string;
  setPatientName: (value: string) => void;
  patientClient: string;
  setPatientClient: (value: string) => void;
  location: any;
  handleAddPatient: (location: string) => void;
};

const AddNewPatientModal = (props: addNewPatientProps) => {
  const {
    modalOpened,
    setModalOpened,
    patientName,
    setPatientName,
    patientClient,
    setPatientClient,
    handleAddPatient,
    location
  } = props;
  const [errorMsg, setErrorMsg] = useState("");
  const onSave = () => {
    if (!patientName || !patientClient) {
      setErrorMsg("Please provide both patient and client names");
      return;
    }
    setErrorMsg("");
    handleAddPatient(location);
  };
  return (
    <Modal
      opened={modalOpened}
      onClose={() => {
        setErrorMsg("");
        setModalOpened(false);
      }}
      title="Add new patient"
    >
      <TextInput
        label="Patient Name"
        placeholder="Enter patient name"
        value={patientName}
        onChange={(event) => setPatientName(event.currentTarget.value)}
        required
      />
      <TextInput
        label="Client Name"
        placeholder="Enter client name"
        value={patientClient}
        onChange={(event) => setPatientClient(event.currentTarget.value)}
        required
      />
      {errorMsg && (
        <Text fz={14} fw={400} c={"red"}>
          {errorMsg}
        </Text>
      )}
      <Group mt="md">
        <Group mt="md">
          <Button onClick={onSave}>Save</Button>
        </Group>
      </Group>
    </Modal>
  );
};
export default AddNewPatientModal;
